import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { MediaService } from 'src/app/shared/services/mediaservice/media.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { AddService } from 'src/app/shared/services/userservices/add.service';
import Swal from 'sweetalert2';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
@Component({
  selector: 'app-create-event',
  templateUrl: './create-event.component.html',
  styleUrls: ['./create-event.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule],
})
export class CreateEventComponent implements OnInit {
  @ViewChild('event_image_input', { static: false }) event_image_input!: ElementRef;
  showSpinner = false;
  fileName: any;
  formData: FormData = new FormData();
  fileExtension: any;
  imagePath: any;
  selectedFileName: string | null = null;
  selectedImage: string | ArrayBuffer | null = null; // This will store the selected image data
  profileImageInvalid = false;
  fileToUpload: any;
  event_date: any;
  event_image: any;
  text = '';
  id: any;
  apidata: any;
  eventName = '';
  eventDate: any;
  eventLocation = '';
  eventType = '';
  eventDetail = '';
  eventImage: any;
  eventNamePath: any;
  event_id: any;
  user: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;

  constructor(
    private mediaService: MediaService,
    private addService: AddService,
    public router: Router,
    public fileInput: ElementRef,
    private route: ActivatedRoute,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,

  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type != "Admin") {
      this.router.navigate(['/dashboard-1']);
    }
  }

  ngOnInit(): void {

    this.route.params.subscribe(params => {
      this.id = params['id'];
      if (this.id !== undefined) {
        this.showEventData(this.id);
      }
    });
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }
  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }

  showEventData(id: any) {
    this.showSpinner = true
    this.addService.eventDetail(id).then((value) => {
      this.apidata = value?.data;
      this.event_id = value?.data[0].id
      this.eventNamePath = this.apidata[0].event_image

      this.eventName = this.apidata[0].event_name
      this.eventDate = this.apidata[0].event_date
      this.eventLocation = this.apidata[0].event_location
      this.eventType = this.apidata[0].event_type
      this.eventDetail = this.apidata[0].event_description



      this.showSpinner = false

    })
  }

  imageUrl = '../../../assets/images/question.jpg';

  goToEventManagement(): void {
    this.router.navigate(['/event-management']);
  }

  trimText() {
    this.text = this.text.replace(/\s+/g, ' ').trim();
  }

  onFileChange(event: any) {
    const selectedFile = event?.target?.files?.[0];

    if (!selectedFile) {
      return;
    }

    const fileSizeKB = selectedFile.size / 1024;

    if (fileSizeKB > 1025) {
      this.clearSelectedFile();
      return;
    }

    this.formData.set('file', selectedFile, selectedFile.name);
    this.uploadDocumentImage();
    this.selectedFileName = selectedFile.name;
    this.profileImageInvalid = false;

    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.selectedImage = e.target.result;
    };
    reader.readAsDataURL(selectedFile);
  }

  clearSelectedFile() {
    this.selectedFileName = null;
    this.selectedImage = null;
    this.profileImageInvalid = true;
    if (this.event_image_input) {
      this.event_image_input.nativeElement.value = ''; // Clear the input value
    }
  }
  triggerFileInput() {
    // Trigger the click event of the hidden file input
    if (this.event_image_input) {
      this.event_image_input.nativeElement.click();
    }
  }
  uploadDocumentImage() {
    this.showSpinner = true;
    this.mediaService
      .uploadImage(this.formData)
      .subscribe(response => {
        this.showSpinner = false;
        let l: any;
        l = response;
        this.imagePath = l.data.path;
      },
        error => {
          this.showSpinner = false;
        }
      );
  }

  onSubmit(f: NgForm) {
    this.showSpinner = true;
    const event_date = new Date(f.value.event_date).toLocaleDateString('en-CA', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });

    this.event_date = event_date.replace(/-/g, '/');
    this.addService.addEvent(
      this.event_id,
      f.value.event_image,
      f.value.event_name,
      this.event_date,
      f.value.event_location,
      f.value.event_type,
      f.value.event_detail,
    )
      .then((value) => {
      });

    this.showSpinner = false;
    this.router.navigate(['/event-management']);
  }

  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }

}
